import type { FC } from 'react';
import { format, isValid } from 'date-fns';

import { Paragraph } from '@zillow/constellation-10';

import TourCardImage from '../TourCard/TourCardImage';
import TourCardSelectableControls from '../TourCard/TourCardSelectableControls';
import TourCardContentContainer from '../TourCard/TourCardContentContainer';
import TourCardContainer from '../TourCard/TourCardContainer';
import type { VrModelProps } from '../../../model/VrModel';
import { singleTextLineStyles } from '../../../styles';

interface TourCardSelectableProps {
  vrModel: Pick<VrModelProps, 'label' | 'createDateTimeUtc' | 'creatorName' | 'posterUrl'>;
  isSelected?: boolean;
  onView: () => void;
  onSelect: () => void;
}

const TourCardSelectable: FC<TourCardSelectableProps> = ({ vrModel, isSelected = false, onView, onSelect }) => (
  <TourCardContainer isSelected={isSelected} hasBigBottomBorder={isSelected}>
    <TourCardImage imageSrc={vrModel.posterUrl} isSelected={isSelected} onClick={onSelect} />
    <TourCardContentContainer>
      <Paragraph textStyle="body-bold" css={{ ...singleTextLineStyles }}>
        {vrModel.label || ''}
      </Paragraph>
      <Paragraph textStyle="body-sm" css={{ ...singleTextLineStyles }}>
        {/* @ts-ignore */}
        {`Created ${vrModel.createDateTimeUtc && isValid(new Date(vrModel.createDateTimeUtc)) ? format(new Date(vrModel.createDateTimeUtc), 'MM/dd/yyyy') : '-'}`}
      </Paragraph>
      <TourCardSelectableControls isSelected={isSelected} onView={onView} onSelect={onSelect} />
    </TourCardContentContainer>
  </TourCardContainer>
);

export default TourCardSelectable;
